import { useState, useCallback } from 'react';

function getStored(key, defaultValue) {
  try {
    const item = localStorage.getItem(key);
    return item !== null ? JSON.parse(item) : defaultValue;
  } catch {
    return defaultValue;
  }
}

export function usePreferences() {
  const [viewMode, setViewModeState] = useState(() => getStored('viewMode', 'grid'));
  const [sidebarOpen, setSidebarOpenState] = useState(() => getStored('sidebarOpen', true));

  const setViewMode = useCallback((mode) => {
    setViewModeState(mode);
    localStorage.setItem('viewMode', JSON.stringify(mode));
  }, []);

  const setSidebarOpen = useCallback((open) => {
    const value = typeof open === 'function' ? open(sidebarOpen) : open;
    setSidebarOpenState(value);
    localStorage.setItem('sidebarOpen', JSON.stringify(value));
  }, [sidebarOpen]);

  return { viewMode, setViewMode, sidebarOpen, setSidebarOpen };
}
